import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  position: relative;
`

export const CloseIcon = styled.div`
  cursor: pointer;
  color: ${colors.strongGray};
  position: absolute;
  top: -20px;
  right: 1px;
`

export const RowGap = styled.div`
  display: flex;
  gap: 16px;
`

export const CheckBoxArea = styled.div`
  display: grid;
  padding: 20px 15.5px;
  grid-template-columns: 1fr 1fr;
  row-gap: 20px;
  border-radius: 12px;
  border: 1px solid ${colors.grayBackground};
`

export const Section = styled.div`
  margin: 12px 0;
`

export const Area = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
